import { cloneElement } from "react";

import { AntdIconProps } from "@ant-design/icons/lib/components/AntdIcon";

export const getSectionGroupIcon = (icon: JSX.Element, color: string) => {
    const iconProps: AntdIconProps = {
        style: { 
            color,
            fontSize: 40
        },
    };

    return cloneElement(icon, { ...iconProps })
};